<template>
  <div>
    <Navigation />
    <div class="main-container">
      <div class="container is-fullhd">
        <h1 class="is-size-2">
          {{ type === "new" ? "create" : type | capitalize }}
          {{ singularItem[title] }}
        </h1>
      </div>
      <div class="container">
        <div class="columns">
          <div class="column ">
            <template v-for="(entry, i) in Object.entries(itemData)">
              <template
                v-if="
                  [
                    'image_1',
                    'image_2',
                    'image_3',
                    'events_image',
                    'business_image',
                    'news_image',
                    'slogan'
                  ].includes(entry[0]) || entry[0].indexOf('desc') > -1
                "
              >
                <div class="columns" :key="'row-' + i">
                  <div
                    class="column is-one-third"
                    :key="'field-' + entry[0] + i"
                  >
                    <strong>
                      {{ entry[0] | cleanTitle | capitalize }}
                    </strong>
                  </div>
                  <div
                    class="column has-text-left"
                    :key="'value-' + entry[0] + i"
                  >
                    <input
                      v-if="
                        ![
                          'image_1',
                          'image_2',
                          'image_3',
                          'events_image',
                          'business_image',
                          'news_image'
                        ].includes(entry[0]) && entry[0].indexOf('desc') === -1
                      "
                      type="text"
                      class="input"
                      v-model="itemData[entry[0]]"
                    />
                    <template
                      v-else-if="
                        ['image_1', 'image_2', 'image_3'].includes(entry[0])
                      "
                    >
                      <UploadImage
                        @updateSettingsLogo="updatePhoto"
                        v-if="
                          (['', null, false, undefined].includes(
                            itemData[entry[0]]
                          ) &&
                            ['image_1', 'image_2', 'image_3'].includes(
                              entry[0]
                            )) ||
                            changeImage[entry[0]]
                        "
                        :upload="upload[entry[0]]"
                        :itemType="'photo'"
                        :index="Object.keys(changeImage).indexOf(entry[0])"
                        :key="'images' + entry[0]"
                        @toggle="() => (changeImage[entry[0]] = false)"
                      />
                      <div v-else>
                        <div>
                          <figure>
                            <img
                              v-if="entry[1]"
                              :src="getImage(entry[1])"
                              id="post-image-preview"
                            />
                            <img
                              v-else
                              src="@/assets/logos/image-unavailable.png"
                              id="post-image-preview"
                            />
                          </figure>
                          <button
                            class="button is-info is-small"
                            @click="
                              changeImage[entry[0]] = !changeImage[entry[0]]
                            "
                          >
                            Change Image
                          </button>
                        </div>
                      </div>
                    </template>
                    <template
                      v-else-if="
                        [
                          'events_image',
                          'business_image',
                          'news_image'
                        ].includes(entry[0])
                      "
                    >
                      <UploadImage
                        @updateSettingsLogo="updatePhoto2"
                        v-if="
                          (['', null, false, undefined].includes(
                            itemData[entry[0]]
                          ) &&
                            ['business', 'events', 'news'].includes(
                              entry[0]
                            )) ||
                            changeImage[entry[0]]
                        "
                        :target="entry[0]"
                        :upload="upload[entry[0]]"
                        :itemType="'photo'"
                        :index="Object.keys(changeImage).indexOf(entry[0])"
                        :key="'hero-images' + entry[0]"
                        @toggle="() => (changeImage[entry[0]] = false)"
                      />
                      <div v-else>
                        <div>
                          <figure>
                            <img
                              v-if="entry[1]"
                              :src="getImage(entry[1])"
                              id="post-image-preview"
                            />
                            <img
                              v-else
                              src="@/assets/logos/image-unavailable.png"
                              id="post-image-preview"
                            />
                          </figure>
                          <button
                            class="button is-info is-small"
                            @click="
                              changeImage[entry[0]] = !changeImage[entry[0]]
                            "
                          >
                            Change Image
                          </button>
                        </div>
                      </div>
                    </template>
                    <textarea
                      v-else
                      :key="'description-' + entry[0]"
                      v-model="itemData[entry[0]]"
                      class="textarea"
                    ></textarea>
                  </div>
                </div>
              </template>
              <template v-else-if="entry[0] === 'welcome_message'">
                <div class="columns" :key="'row-' + i">
                  <div class="column is-one-third" :key="'editor-' + i">
                    <p :key="'field-' + entry[0] + i">
                      <strong>
                        {{ entry[0] | cleanTitle | capitalize }}
                      </strong>
                    </p>
                  </div>
                  <div class="column">
                    <Editor
                      :key="'welcome-' + entry[0]"
                      :content="entry[1]"
                      @updateContent="updateContent"
                      style="width:100%;"
                    />
                  </div>
                </div>
              </template>
              <template v-else></template>
            </template>
          </div>
        </div>
        <div class="columns">
          <div class="column is-one-third"></div>
          <div class="column">
            <p class="has-text-right">
              <button class="button is-success" @click="saveItemData">
                Update Home Page
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navigation from "@/components/Navigation.vue";
import Editor from "@/components/Editor.vue";
import UploadImage from "@/components/UploadImage.vue";
import singularItem from "@/helpers/singularItems.js";
import axios from "axios";
import moment from "moment";


export default {
  name: "HomePage",
  data() {
    return {
      item: {},
      singularItem: singularItem,
      upload: {
        image_1: false,
        image_2: false,
        image_3: false,
        business_image: false,
        news_image: false,
        events_image: false
      },
      changeImage: {
        image_1: false,
        image_2: false,
        image_3: false,
        business_image: false,
        news_image: false,
        events_image: false
      }
    };
  },
  components: {
    Editor: Editor,
    UploadImage: UploadImage,
    Navigation: Navigation
  },
  mounted() {
    if (!Object.keys(this.itemData).length) this.getItemData();
  },
  methods: {
    updateContent(value) {
      if (Object.keys(this.itemData).includes("welcome_message")) {
        this.itemData.welcome_message = value;
      }
    },
    updatePhoto(value) {
      const key = `image_${value.index + 1}`;
      this.itemData[key] = value.photo;
      this.changeImage[key] = false;
      this.upload[key] = false;
    },
    updatePhoto2(value) {
      console.log(value);
      const key = value.target;
      this.itemData[key] = value.photo;
      this.changeImage[key] = false;
      this.upload[key] = false;
    },
    updateFile(value) {
      if (Object.keys(this.itemData).includes("file")) {
        this.itemData.file = value;
      }
    },
    getImage(img) {
      return process.env.VUE_APP_SERVER + "uploads/" + img;
    },
    getItemData() {
      axios
        .get(process.env.VUE_APP_SERVER + "homepage/1")
        .then(res => {
          if (res.data && res.data.result && res.data.result.length) {
            this.itemData = res.data.result[0];
          } else {
            axios
              .get(process.env.VUE_APP_SERVER + "fields/homepage")
              .then(res => {
                if (res.data && res.data.result && res.data.result.length) {
                  const ItemData = {};
                  res.data.result.forEach(r => {
                    ItemData[r] = "";
                  });
                  this.itemData = ItemData;
                }
              })
              .catch(error => {
                this.$noty.error(error);
              });
          }
        })
        .catch(error => {
          console.error(error);
        });
    },
    saveItemData() {
      const updates = { ...this.itemData };
      const id = updates.id;
      Object.keys(updates).forEach(k => {
        if (!updates[k]) delete updates[k];
      });
      delete updates.id;
      let url = process.env.VUE_APP_SERVER + "homepage/update/" + id;
      axios
        .post(url, { details: updates })
        .then(res => {
          if (res.data && res.data.result && res.data.message === "Success") {
            this.$noty.success("Home page updated!");
          }
          this.getItemData();
        })
        .catch(() => {
          this.$noty.error("Couldn't update the homepage content.");
        });
    }
  },
  computed: {
    title() {
      return this.$route.params.title;
    },
    type() {
      return this.$route.params.type;
    },
    id() {
      return 1;
    },
    itemData: {
      get() {
        return this.item;
      },
      set(value) {
        this.item = value;
      }
    }
  },
  filters: {
    capitalize(value) {
      if (value && value !== "agm")
        return value[0].toUpperCase() + value.substring(1);
      else if (value && value === "agm") return value.toUpperCase();
      else return value;
    },
    cleanTitle(value) {
      if (value) return value.replace(/_/g, " ");
      else return value;
    },
    niceDate(value) {
      if (value) return moment(value).format("MMMM Do YYYY, h:mm a");
      else return value;
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/basic.scss";
.active-status {
  display: inline-block;
  margin-top: 0.5rem;
  &:hover {
    cursor: pointer;
  }
}

.photo-container {
  width: calc((100% / 2) - 1rem);
  display: inline-block;
  margin: 0.5rem;
}
</style>
